import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef, GridValidRowModel } from '@mui/x-data-grid-pro';
import BooleanCell from 'components/shared/Table/TableCell/DataGrid/BooleanCell';

export const useColumnDefinitions = (): GridColDef[] => {
  const { t } = useTranslation('common', {
    keyPrefix: 'adminPortal.configurations'
  });

  return useMemo<GridColDef<GridValidRowModel>[]>(
    () => [
      {
        field: 'name',
        type: 'string',
        headerName: t('name'),
        flex: 1,
        align: 'left'
      },
      {
        field: 'configurationSettings',
        type: 'string',
        flex: 1,
        align: 'left',
        headerName: t('configurationSettings'),
        valueGetter: (_, row) => {
          const { configurationSettings } = row;
          const schedulingSettings = configurationSettings.map(
            (setting) => setting?.schedulingSetting
          );
          const keys = schedulingSettings.map((setting) => setting?.key);
          return keys.join(', ');
        }
      },
      {
        field: 'planningEntities.key',
        type: 'string',
        flex: 1,
        align: 'left',
        headerName: t('planningEntities'),
        valueGetter: (_, row) => {
          const { planningEntities } = row;
          const id = planningEntities.map((entity) => entity?.id);
          return id.join(', ');
        }
      },
      {
        field: 'isDefault',
        type: 'boolean',
        flex: 1,
        align: 'left',
        headerName: t('default'),
        renderCell: BooleanCell
      }
    ],
    []
  );
};
